import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  // 10 minutes = 600 seconds
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('countdown_time');
    if (saved !== null) {
      const parsed = parseInt(saved, 10);
      // If it's already 0 or less, keep it at 0. Otherwise return the saved time.
      return parsed > 0 ? parsed : 0;
    }
    return 600;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev - 1;
        localStorage.setItem('countdown_time', newTime.toString());
        return newTime;
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-1 px-4 shadow-sm" data-id="element-249">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-1 md:gap-3 text-xs font-medium" data-id="element-250">
        <span className="text-center" data-id="element-251">
          Oferta por tiempo limitado hasta agotar los primeros 20 lugares
        </span>
        <div className="flex items-center gap-1 bg-red-800/40 px-2 py-0.5 rounded-full font-bold tracking-wide" data-id="element-252">
          <Clock className={`w-3 h-3 ${timeLeft > 0 ? 'animate-pulse' : ''}`} data-id="element-253" />
          <span data-id="element-254">{formattedTime}</span>
        </div>
      </div>
    </div>;
}